/* eslint-disable */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'components/Checkbox';
import { useCombinedRefs } from 'common';
import styled from './styles';

const CheckboxCell = React.forwardRef((props, ref) => {
  const {
    value, onChange, wrapperProps, ...otherProps
  } = props;
  const checkboxRef = useRef(null);
  const combinedCheckboxRef = useCombinedRefs(checkboxRef, ref);
  const [checked, setIsChecked] = useState(value);
  // This is for style the wrapping div of this component managed by Ag-grid. This cannot be moved into style sheet as css can't select parent container.
  if (props.reactContainer) {
    props.reactContainer.style.height = '100%'; // eslint-disable-line no-param-reassign
  }

  return (
    <styled.CheckboxCell {...wrapperProps}>
      <Checkbox
        ref={combinedCheckboxRef}
        checked={checked}
        onChange={(event) => {
          event.persist();
          setIsChecked(event.target.checked);
          // updates the row data of the row
          props.node.setDataValue(props.column.colId, !props.value);
          // Focus the currently clicked toggle button as the focus is lost after state change
          props.api.setFocusedCell(props.node.rowIndex, props.column.colId);
          onChange &&
            onChange({
              event,
              node: props.node,
              api: props.api,
              value
            });
        }}
        {...otherProps}
      />
    </styled.CheckboxCell>
  );
});
CheckboxCell.propTypes = {
  /** value for this cell that is passed in from DataGrid  */
  value: PropTypes.bool.isRequired,
  /**
   * onChange callback for Checkbox.
   * Return payload: `{ event, node, api, value }`,
   * event: The event source of the callback.
   * node: current row node,
   * api: grid api
   * value: value for this cell that is passed in from DataGrid
   */
  onChange: PropTypes.func,
  /** Props just for the wrapper div */
  wrapperProps: PropTypes.shape({})
};
CheckboxCell.defaultProps = {
  onChange: undefined,
  wrapperProps: {}
};
CheckboxCell.displayName = 'CheckboxCell';
export default CheckboxCell;
